import { subMonths } from 'date-fns';

/**
 * Takes date, months to subtract and optional UTC format and returns a string with a language sensitive representation of the date portion of date - months.
 * @param date
 * @param months
 * @returns string date
 * @example
 * ```
 * subtractMonths(new Date(), 12) //=> Wed Mar 09 2022 16:43:55 GMT+0100 (Central European Standard Time)
 * ```
 */

export const subtractMonths = (date: Date, months: number) => {
  return subMonths(date, months);
};
